/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { AbandonedImageAssetsCleanUpRequestBuilderNavigationMetadata, AbandonedImageAssetsCleanUpRequestBuilderRequestsMetadata, type AbandonedImageAssetsCleanUpRequestBuilder } from './abandonedImageAssetsCleanUp/index.js';
// @ts-ignore
import { DanglingImageAssignmentsCleanUpRequestBuilderNavigationMetadata, DanglingImageAssignmentsCleanUpRequestBuilderRequestsMetadata, type DanglingImageAssignmentsCleanUpRequestBuilder } from './danglingImageAssignmentsCleanUp/index.js';
// @ts-ignore
import { ImagesCleanUpRequestBuilderNavigationMetadata, ImagesCleanUpRequestBuilderRequestsMetadata, type ImagesCleanUpRequestBuilder } from './imagesCleanUp/index.js';
// @ts-ignore
import { ImageTrashPurgeRequestBuilderNavigationMetadata, ImageTrashPurgeRequestBuilderRequestsMetadata, type ImageTrashPurgeRequestBuilder } from './imageTrashPurge/index.js';
// @ts-ignore
import { TestRequestBuilderRequestsMetadata, type TestRequestBuilder } from './test/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/jobs
 */
export interface JobsRequestBuilder extends BaseRequestBuilder<JobsRequestBuilder> {
    /**
     * The abandonedImageAssetsCleanUp property
     */
    get abandonedImageAssetsCleanUp(): AbandonedImageAssetsCleanUpRequestBuilder;
    /**
     * The danglingImageAssignmentsCleanUp property
     */
    get danglingImageAssignmentsCleanUp(): DanglingImageAssignmentsCleanUpRequestBuilder;
    /**
     * The imagesCleanUp property
     */
    get imagesCleanUp(): ImagesCleanUpRequestBuilder;
    /**
     * The imageTrashPurge property
     */
    get imageTrashPurge(): ImageTrashPurgeRequestBuilder;
    /**
     * The test property
     */
    get test(): TestRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const JobsRequestBuilderUriTemplate = "{+baseurl}/api/jobs";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const JobsRequestBuilderNavigationMetadata: Record<Exclude<keyof JobsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    abandonedImageAssetsCleanUp: {
        requestsMetadata: AbandonedImageAssetsCleanUpRequestBuilderRequestsMetadata,
        navigationMetadata: AbandonedImageAssetsCleanUpRequestBuilderNavigationMetadata,
    },
    danglingImageAssignmentsCleanUp: {
        requestsMetadata: DanglingImageAssignmentsCleanUpRequestBuilderRequestsMetadata,
        navigationMetadata: DanglingImageAssignmentsCleanUpRequestBuilderNavigationMetadata,
    },
    imagesCleanUp: {
        requestsMetadata: ImagesCleanUpRequestBuilderRequestsMetadata,
        navigationMetadata: ImagesCleanUpRequestBuilderNavigationMetadata,
    },
    imageTrashPurge: {
        requestsMetadata: ImageTrashPurgeRequestBuilderRequestsMetadata,
        navigationMetadata: ImageTrashPurgeRequestBuilderNavigationMetadata,
    },
    test: {
        requestsMetadata: TestRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
